import { SerializedFields } from 'node_modules/@langchain/core/dist/load/map_keys';

const UNACCEPTED_KWARGS_MAPPING: Record<string, string[]> = {
  ChatOpenAI: ['azure_openai_api_key', 'openai_api_base'],
  CustomModelEndpoint: ['openai_api_base'],
};

export function hasNotImplemented(val: unknown): boolean {
  if (val === 'not_implemented') return true;
  if (typeof val !== 'object' || val === null) return false;
  return Object.values(val).some((value) => hasNotImplemented(value));
}

export function cleanNotImplemented(val: unknown, maxDepth = 10): unknown {
  if (maxDepth <= 0) return val;
  if (val === 'not_implemented') return val;
  if (Array.isArray(val)) return val;
  if (typeof val !== 'object' || val === null) return val;

  // For objects, recursively clean nested objects
  const obj = val as Record<string, unknown>;
  const cleaned = Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [
      k,
      cleanNotImplemented(v, maxDepth - 1),
    ])
  );

  // If any nested value contains 'not_implemented', return undefined
  if (hasNotImplemented(cleaned)) {
    return undefined;
  }

  return cleaned;
}

export function filterAndCombineKwargs(
  provider: string,
  kwargs?: SerializedFields
): Record<string, unknown> {
  // kwargs?.model_kwargs contains all of the invocation params that were unrecognized
  // so spread them here with the kwargs to ensure they're recognized in the playground
  // and then remove the model_kwargs field itself
  const allKwargs: Record<string, unknown> = {
    ...kwargs,
    ...kwargs?.model_kwargs,
  };
  delete allKwargs.model_kwargs;

  if (!provider || !allKwargs) return allKwargs;
  const unacceptedKwargs = UNACCEPTED_KWARGS_MAPPING[provider] ?? [];
  if (!unacceptedKwargs) return allKwargs;

  const cleaned = Object.fromEntries(
    Object.entries(allKwargs)
      .filter(([key]) => !unacceptedKwargs.includes(key))
      .map(([key, value]) => {
        const cleanedValue = cleanNotImplemented(value);
        return [key, cleanedValue];
      })
      .filter((entry): entry is [string, unknown] => entry[1] !== undefined)
  );

  return cleaned;
}
